import React, { useState } from 'react'
import { BadgeCheck, Building2, ChevronRight } from 'lucide-react'
import { PLATFORM_BRAND_NAME, PLATFORM_HAS_UDYAM } from '../constants/platformBusiness'
import { PlatformBusinessRegistrationModal } from './PlatformBusinessRegistrationModal'

type PlatformBusinessRegistrationProps = {
  /** `auth` = login/claim footer; `sidebar` = dashboard sidebar */
  variant?: 'auth' | 'sidebar'
  className?: string
}

const PlatformBusinessRegistration: React.FC<PlatformBusinessRegistrationProps> = ({
  variant = 'auth',
  className = '',
}) => {
  const [open, setOpen] = useState(false)

  const modal = <PlatformBusinessRegistrationModal open={open} onClose={() => setOpen(false)} />

  if (variant === 'sidebar') {
    return (
      <>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className={`group w-full flex items-center gap-2.5 rounded-xl px-2 py-2 text-left hover:bg-white/50 transition-colors ${className}`}
        >
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-primary-100 to-primary-50 text-primary-600 ring-1 ring-primary-100/80">
            <Building2 className="h-4 w-4" aria-hidden />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-[10px] font-medium uppercase tracking-wide text-gray-400">
              Operated by
            </span>
            <span className="flex items-center gap-1.5 mt-0.5">
              <span className="text-xs font-semibold text-gray-800 lowercase truncate">{PLATFORM_BRAND_NAME}</span>
              {PLATFORM_HAS_UDYAM ? (
                <BadgeCheck className="h-3.5 w-3.5 text-emerald-600 shrink-0" aria-label="Udyam registered" />
              ) : null}
            </span>
          </span>
          <ChevronRight className="h-4 w-4 text-gray-400 shrink-0 group-hover:text-primary-600 transition-colors" />
        </button>
        {modal}
      </>
    )
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`group w-full flex items-center gap-3 rounded-xl border border-white/50 bg-white/40 backdrop-blur-sm px-4 py-3 text-left hover:bg-white/60 transition-colors ${className}`}
      >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
          <Building2 className="h-4 w-4" aria-hidden />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-[10px] font-medium uppercase tracking-wide text-gray-500">Platform operator</span>
          <span className="flex items-center gap-1.5 mt-0.5">
            <span className="text-sm font-semibold text-gray-800 lowercase">{PLATFORM_BRAND_NAME}</span>
            {PLATFORM_HAS_UDYAM ? (
              <span className="inline-flex items-center gap-0.5 text-xs text-emerald-700 font-medium">
                <BadgeCheck className="h-3.5 w-3.5 shrink-0" aria-hidden />
                Udyam
              </span>
            ) : null}
          </span>
          <span className="text-xs text-primary-600 group-hover:text-primary-700 mt-1 block">
            View registration details
          </span>
        </span>
        <ChevronRight className="h-4 w-4 text-gray-400 shrink-0 group-hover:text-primary-600 transition-colors" />
      </button>
      {modal}
    </>
  )
}

export default PlatformBusinessRegistration
